import React, { useState, useEffect } from 'react';
import { DownOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Form, Input, Radio, message, Upload, Modal, Row, Col, ConfigProvider, Dropdown } from 'antd';
import defaultHeadImg from '@/assets/default.png'
import { getUser, request, setUser } from "@/utils";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.less";
import AliyunOSSUpload from "@/components/AliyunOssComponent";
import AliyunOSSUploadImg from "@/components/AliyunOssComponent/index2";
import defaultAvatar from '@/assets/default.png'
import Config from "@/config/config";
import { Func } from "@/utils/func";
import { use } from 'react';

export default function UserInfoComponent(props) {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [info, setInfo] = useState({})
    const [areCode, setAreaCode] = useState('86')
    const navigate = useNavigate()
    useEffect(() => {
        let user = getUser()
        setInfo({ ...user })
        setAreaCode(user?.nation_code || '86')
    }, [])
    const handleNickname = (e) => {

        if (e.target.value.length > 20) {
            e.target.value = e.target.value.slice(0, 20); // 截断超出长度的值
        }
        info.nickname = e.target.value
        setInfo({ ...info })
    }
    const handlEnname = (e, key) => {
        // <｜placeholder｜>
        const value = e.target.value;
        // 验证输入是否只包含英文和空格
        if (/^[a-zA-Z\s]*$/.test(value)) {
            const newInfo = { ...info };
            newInfo[key] = value;
            setInfo(newInfo);
        } else {
            // 若输入不合法，恢复上一次的值
            e.target.value = info[key] || '';
            message.warning('只能输入英文和空格');
        }
        // newInfo[key] = value;
        // setInfo(newInfo);
    }
    const fetchData = async () => {
        try {
            const response = await request.get('auth/info'); // 使用封装好的Axios实例发送GET请求
            if (response.code) {
                message.error(response.msg)
            } else {
                setInfo(response.data)
                setUser(response.data)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    const subInfo = async () => {
        console.log(sessionStorage.getItem('user'))
        if (!info.nickname.trim()) {
            message.error('请输入昵称')
            return
        }
        if (info?.nickname?.trim().length < 2) {
            message.error('昵称不能小于2个字符')
            return
        }
        if (!info?.first_name?.trim() || !info?.last_name?.trim()) {
            message.error('请输入英文姓和名')
            return
        }
        if (info?.first_name?.trim().length < 2 || info?.last_name?.trim().length < 2) {
            message.error('英文姓和名不能小于2个字符')
            return
        }
        if (!info.mobile) {
            message.error('请输入手机号码')
            return
        }
        const mobileRegex = /^1[3-9]\d{9}$/;
        if (areCode === '86') {
            if (!mobileRegex.test(info.mobile)) {
                message.error('请输入正确的手机号');
                return;
            }
        }
        if (!info.email) {
            message.error('请输入邮箱')
            return
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(info.email)) {
            message.error('请输入有效的邮箱地址');
            return;
        }
        try {
            const response = await request.post('auth/update-user',
                {
                    id: JSON.parse(sessionStorage.getItem('user')).uid || JSON.parse(sessionStorage.getItem('user')).id,
                    nickname: info.nickname,
                    last_name: info.last_name,
                    first_name: info.first_name,
                    email: info.email,
                    mobile: info.mobile,
                    nation_code: areCode
                });
            if (response.code) {
                message.error(response.msg)
            } else {
                message.success('保存成功', 0.5)
                fetchData()
                if (searchParams.get('typ') == '1') {
                    navigate('/')
                } else {
                    navigate(-1);
                }
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }

    const modifyAvatar = async (avatar = '') => {
        try {
            const response = await request.post('auth/update-user', { id: info.id, avatar: avatar ? avatar : info.avatar });
            if (response.code) {
                message.error(response.ret.cn)
            } else {
                message.success('头像修改成功', 0.5, () => { window.location.reload() })
                let user = getUser()
                user.avatar = info.avatar
                setUser(user)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }


    const imgUploadResult = (v) => {
        if (v[v.length - 1]['status'] === "done") {
            const imgUrl = v[v.length - 1]['url'];
            const ossPrefix = Config.imgPrefix;
            modifyAvatar(imgUrl)
            info.avatar = imgUrl
            setInfo({ ...info });
            console.log(v);
        }
    }


    useEffect(() => {

        // fetchData();
    }, [])

    const items = [
        {
            key: '1',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('86') }}>
                    <span className='code'> +86 </span><span>中国大陆</span>
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('852') }}>
                    <span className='code' > +852 </span><span>中国香港</span>
                </div>
            ),

        },
        {
            key: '3',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('886') }}>
                    <span className='code'> +886 </span><span>中国台湾</span>
                </div>
            ),
        },
        {
            key: '4',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('853') }}>
                    <span className='code'> +853 </span><span>中国澳门</span>
                </div>
            ),
        },
        {
            key: '5',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('81') }}>
                    <span className='code'> +81 </span><span>日本</span>
                </div>
            ),
        },
    ];
    return (
        <div className="userinfo-from">
            <div className="userinfo-title">
                完善个人信息
            </div>
            <div className="userinfo-img">
                <img style={{ borderRadius: "50%" }} src={info.avatar ? Func.imgUrlFormat(info.avatar) : defaultAvatar} width="100%" height="100%" alt="" />
            </div>
            {/*<Upload showUploadList={false} {...props}>*/}
            {/*    <Button icon={<UploadOutlined/>} style={{marginLeft:"20px"}}>上传图片</Button>*/}
            {/*</Upload>*/}
            <div><AliyunOSSUpload onChange={imgUploadResult} type="avatar" /></div>
            <div className="userinfo-item-box">
                <div className="userinfo-label">
                    昵称:
                </div>
                <div className="userinfo-input">
                    <Input placeholder="请输入您的昵称" maxLength={20} onChange={handleNickname} value={info.nickname} />
                </div>
                <div className="userinfo-label">
                    <div className="userinfo-label-item">英文姓：</div>
                    <div className="userinfo-label-item">英文名：</div>
                </div>
                <div className="userinfo-input">
                    <Input placeholder="请输入英文姓" maxLength={20} onChange={(e) => handlEnname(e, 'last_name')} className='userinfo-input-item' value={info.last_name} />
                    <Input placeholder="请输入英文名" maxLength={20} onChange={(e) => handlEnname(e, 'first_name')} className='userinfo-input-item' value={info.first_name} />
                </div>
                <div className="userinfo-label">手机号码:</div>
                <div className='userinfo-input-sty'>
                    <Dropdown menu={{ items }} trigger={['click']}>
                        <div className='areaCode'>
                            <div className='codeValue' >+{areCode}</div>
                            <DownOutlined style={{ fontSize: '14px' }} />
                        </div>
                    </Dropdown>
                    <Input placeholder="请输入手机号码" value={info.mobile} className='intsty' onInput={(e) => {
                        info.mobile = e.target.value
                        setInfo({ ...info })
                    }} />
                </div>
                <div className="userinfo-label">邮箱:</div>
                <div className='userinfo-input'>
                    <Input placeholder="请输入邮箱" value={info.email} onInput={(e) => {
                        info.email = e.target.value
                        setInfo({ ...info })
                    }} />
                </div>

            </div>
            <div className="userinfo-btn">
                <Button type="primary" style={{ width: '120px', height: '40px' }} onClick={subInfo}>确定</Button>
            </div>
        </div>
    )
}
